import React from "react";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import { informal } from "../utilities/date";
import Radium from "radium";
import { sm, md, lg } from "../utilities/styles";

let cropMaskStyles = {
  maxHeight: "200px",
  overflow: "hidden",
};

sm(cropMaskStyles, {
  maxHeight: "300px",
});

md(cropMaskStyles, {
  maxHeight: "400px",
});

lg(cropMaskStyles, {
  maxHeight: "700px",
});

export { cropMaskStyles };

const generateSourceSet = (image) => {
  const sizes = [300, 400, 500, 700, 900, 1200, 1500, 2000];
  return sizes
    .map((size) => {
      return `${image}?w=${size} ${size}w`;
    })
    .join(", ");
};

const ArticlePost = ({ post }) => {
  const humanlyIssue = post.humanlyIssue;
  const link = "/post/" + post.id;

  return (
    <div>
      <div className="mt1 px3">
        {humanlyIssue && (
          <HashLink to={"/humanly#issues"}>
            <div>
              <p className="my0">
                <span className="article__timestamp--home mb1">
                  {post.datePosted ? informal(new Date(post.datePosted)) : ""}
                </span>{" "}
                | <span style={{ fontSize: ".8em" }}>HUMANLY</span>
              </p>
            </div>
          </HashLink>
        )}
        {!humanlyIssue && (
          <HashLink to={"/news"}>
            <div>
              <p className="my0">
                <span className="article__timestamp--home mb1">
                  {post.datePosted ? informal(new Date(post.datePosted)) : ""}
                </span>{" "}
                |{" "}
                <span style={{ fontSize: ".8em", textTransform: "uppercase" }}>
                  {post.type ? post.type : "CO-OP NEWS"}
                </span>
              </p>
            </div>
          </HashLink>
        )}
        <h2 className={"bold mb1 mt0"}>
          <Link to={link}>{post.title}</Link>
        </h2>
        <p className="article__subtitle--home mt0">{post.subtitle}</p>
      </div>
      {post.leadImage && post.leadImage.fields.file && (
        <div style={cropMaskStyles}>
          <Link to={link}>
            <img srcSet={generateSourceSet(post.leadImage.fields.file.url)} />
          </Link>
        </div>
      )}
    </div>
  );
};

export default Radium(ArticlePost);



// WEBPACK FOOTER //
// ./src/components/ArticlePost.js